<div class="{{blockData.classes}}"
    *ngIf="hasBlockItems"
    (finderInViewport)="inViewport($event)"
    [requireFullElement]="requireFullElement"
    [addedOffset]="addedOffset"
    [ngClass]="blockData.style"
>
    <div
        [ngClass]="getClasses(item.blockClasses)"
        [finderClipPath]="getClipPath(blockData, item, index)"
        *ngFor="let item of blockData.items; let index = index;"
        (finderInViewport)="analyticsFireTrackSeen(item.analyticsProgressionLinkId)"
    >
        <header *ngIf="'heading' === item.type" [ngClass]="item.classes">
            <finder-component-header
                [data]="blockData.headerData"
            ></finder-component-header>
        </header>
        <p *ngIf="'text' === item.type"
            [ngClass]="item.classes"
            [innerHtml]="item.text | safeHtml"></p>
        <span *ngIf="'info' === item.type" [class]="item.classes">
            <ng-container *ngTemplateOutlet="info"></ng-container>
        </span>
        <span *ngIf="'image' === item.type">
            <ng-container *ngTemplateOutlet="image; context: { $implicit: item }"></ng-container>
        </span>
        <span *ngIf="'cinemagraph' === item.type">
            <ng-container *ngTemplateOutlet="cinemagraph; context: { $implicit: item }"></ng-container>
        </span>
        <ng-template #link>
            <a *ngIf="'link' === item.type"
                finderLocale
                finderLinkId
                finderRouterLink
                [linkId]="item.linkId"
                [class]="item.classes"
                [ngClass]="{'has-cinemagraph': item.hasCinemagraph}"
                [attr.href]="item.href"
                [attr.target]="item.target"
                [id]="item.analyticsProgressionLinkId"
                (focus)="restartVideo($event)"
                [attr.gradient-overlay]="item.gradientOverlay || blockData.gradientOverlay"
            >
                <ng-container *ngTemplateOutlet="info"></ng-container>
            </a>
        </ng-template>
        <ng-template #info>
            <span *ngFor="let linkItem of item.items" [ngClass]="getLinkItemCss(linkItem)">
                <p *ngIf="'text' === linkItem.type"
                    [class]="linkItem.classes"
                    [innerHtml]="linkItem.text | safeHtml"
                ></p>
                <span *ngIf="'title' === linkItem.type"
                    [class]="linkItem.classes"
                    [ngClass]="{'has-paragraph' : linkItem.items.length === 1}"
                    [ngStyle]="linkItem.ngStyle"
                >
                    <ng-container *ngFor="let titleText of linkItem.items">
                        <ng-container *ngIf="'text' === titleText.type">
                            <h3 *ngIf="titleText.classes | isTitle"
                                [class]="titleText.classes">
                                <ng-container *ngTemplateOutlet="text"></ng-container>
                            </h3>
                            <p *ngIf="!(titleText.classes | isTitle)"
                                [class]="titleText.classes">
                                <ng-container *ngTemplateOutlet="text"></ng-container>
                            </p>
                            <ng-template #text>
                                <span class="dynamic-html" [innerHtml]="titleText.text | safeHtml"  [ngClass]="styleClass"></span>
                                <finder-font-icon
                                    class="title-icon"
                                    *ngIf="titleText.icon"
                                    [color]="linkItem.ngStyle?.color"
                                    [name]="titleText.icon"
                                    [title]="titleText.iconTitle">
                                </finder-font-icon>
                            </ng-template>
                        </ng-container>
                    </ng-container>
                </span>
                <ng-container *ngIf="'image' === linkItem.type">
                    <ng-container *ngTemplateOutlet="image; context: { $implicit: linkItem }"></ng-container>
                </ng-container>
                <ng-container *ngIf="'cinemagraph' === linkItem.type">
                    <ng-container *ngTemplateOutlet="cinemagraph; context: { $implicit: linkItem }"></ng-container>
                </ng-container>
                <a *ngIf="'cta' === linkItem.type"
                    finderLocale
                    finderLinkId
                    finderRouterLink
                    [linkId]="linkItem.linkId"
                    [attr.href]="linkItem.textUrl"
                    [attr.target]="linkItem.target"
                >{{linkItem.text}}</a>
                <finder-font-icon
                    *ngIf="'link' === item.type && 'title' === linkItem?.type"
                    class="arrow-decorator"
                    name="next-2"
                    aria-hidden="true"
                    role="presentation">
                </finder-font-icon>
            </span>
        </ng-template>
        <ng-template #image let-linkItem>
            <span [ngSwitch]="!!linkItem.pixiePlayerId">
                <span *ngSwitchCase="true"
                    class="cinemagraph-wrapper"
                    (mouseenter)="restartVideo($event)">
                    <finder-picture [picture]="linkItem.picture" class="fit {{linkItem.classes}}" [ngClass]="styleClass"></finder-picture>
                    <finder-player-block
                        class="cinemagraph"
                        [ngClass]="linkItem.classes"
                        [playerId]="linkItem.pixiePlayerId">
                    </finder-player-block>
                </span>
                <span *ngSwitchCase="false">
                    <finder-picture [picture]="linkItem.picture" class="fit {{linkItem.classes}}" [ngClass]="styleClass"></finder-picture>
                </span>
            </span>
        </ng-template>
        <ng-template #cinemagraph let-linkItem>
            <video *ngIf="linkItem.autoplay"
                class="cinemagraph no-media-autotrack"
                [ngClass]="linkItem.classes"
                [src]="linkItem.picture.desktop"
                [autoplay]="true"
                loop
                [muted]="true"
                playsinline
                tabindex="-1"
                [attr.alt]="linkItem.picture.alt || 'cinemagraph'"
                [attr.aria-label]="linkItem.picture.alt || 'cinemagraph'"
            ></video>
            <video *ngIf="!linkItem.autoplay"
                [muted]="true"
                loop
                tabindex="-1"
                class="cinemagraph"
                [attr.alt]="linkItem.picture.alt || 'cinemagraph'"
                [attr.aria-label]="linkItem.picture.alt || 'cinemagraph'"
                [ngClass]="linkItem.classes"
                [src]="linkItem.picture.desktop"
            ></video>
        </ng-template>
        <!-- Flow:
            * If an "image animation", pass content into finder-animation
            * If a "block animation" add the animation _and_ the content
            * If no animation just show the content
        -->
        <ng-container *ngIf="item.animation && item.animation.location !== '0' && item.animation.style !== 'block'; else second">
            <finder-animation [data]="item.animation">
                <ng-container *ngTemplateOutlet="link"></ng-container>
            </finder-animation>
        </ng-container>
        <ng-template #second>
            <ng-container *ngIf="item.animation && item.animation.location !== '0'; else third">
                <finder-animation
                    [data]="item.animation"
                    *ngIf="item.animation; else link">
                </finder-animation>
                <ng-container *ngTemplateOutlet="link"></ng-container>
            </ng-container>
        </ng-template>
        <ng-template #third>
            <ng-container *ngTemplateOutlet="link"></ng-container>
        </ng-template>
    </div>
</div>
